export default __webpack_public_path__ + "static/facts-eb9832c8f0745b7bf05e9ea193a7b020.webp";